// extracted by mini-css-extract-plugin
module.exports = {"alert":"_DW4Xnu4n","blueAlert":"_7BLE3OVK","titleContainer":"_5BugDUQi","icon":"_kZlMM-Q-","greyIcon":"_SSGXuX8t","googleText":"_x_5k-kMw","text":"_M2wfzrD1"};